'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultStyles = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral([''], ['']);

exports.SchoolListComponent = SchoolListComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _bduiStyles = require('@bd/bdui-styles');

var _bduiStyles2 = _interopRequireDefault(_bduiStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var defaultStyles = exports.defaultStyles = (0, _bduiStyles.css)(_templateObject);

function attachSchoolLevels(schools) {
  return (0, _lodash.sortBy)(schools.map(function (school) {
    var levels = {
      Elementary: (0, _lodash.get)(school, 'gradeRange', '').indexOf('PK') === 0 || (0, _lodash.get)(school, 'gradeRange', '').indexOf('P') === 0 || (0, _lodash.get)(school, 'gradeRange', '').indexOf('K') === 0 || (0, _lodash.get)(school, 'gradeRange[0]') <= 2,
      Middle: (0, _lodash.get)(school, 'gradeRange[0]') > 4 && (0, _lodash.get)(school, 'gradeRange[0]') < 7,
      High: (0, _lodash.get)(school, 'gradeRange[0]') > 7
    };

    var level = Object.keys(levels).find(function (key) {
      return levels[key] === true;
    });
    var order = Object.keys(levels).indexOf(level);

    return _extends({}, school, {
      level: (level || '') + ' School ' + (school.type === 'private' ? '(Private)' : ''),
      order: order
    });
  }), 'order');
}

function SchoolListComponent(_ref) {
  var className = _ref.className,
      schools = _ref.schools;

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'div',
      { className: 'SchoolList_wrapper' },
      _react2.default.createElement(
        'div',
        { className: 'SchoolList_inner' },
        _react2.default.createElement(
          'ul',
          { className: 'SchoolList_list' },
          attachSchoolLevels(schools).map(function (school) {
            var linkPath = school.overviewLink || !Array.isArray(school.website) && school.website;

            return _react2.default.createElement(
              'li',
              { key: school.name, className: 'SchoolList_school' },
              _react2.default.createElement(
                'span',
                { className: 'SchoolList_schoolLevel' },
                school.level
              ),
              _react2.default.createElement(
                'span',
                { className: 'SchoolList_schoolName' },
                linkPath && _react2.default.createElement(
                  'a',
                  { href: linkPath, className: 'SchooList_schoolNameLink', target: '_blank', rel: 'noopener noreferrer' },
                  school.name
                ),
                !linkPath && school.name
              )
            );
          })
        )
      )
    )
  );
}

SchoolListComponent.propTypes = {
  className: _propTypes2.default.string,
  schools: _propTypes2.default.arrayOf(_propTypes2.default.object)
};
SchoolListComponent.defaultProps = {
  className: undefined,
  schools: []
};

exports.default = (0, _bduiStyles2.default)(defaultStyles)(SchoolListComponent);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-schoollist/build/SchoolList.js
// module id = 1281
// module chunks = 0